import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Select, InputNumber } from "antd";
import Spinner from "../common/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  createDonerAction,
  getAllDistrict,
  getAllProvince,
} from "../../store/actions/donerAction";

const AddBlood = () => {
  const [createDonerForm] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProvince());
  }, [dispatch]);

  const onChangeProvince = (id) => {
    dispatch(getAllDistrict(id));
  };

  const resourceState = useSelector((state) => {
    return state.donerReducer;
  });

  const createDonerSubmit = (values) => {
    values.age = values.age.toString();
    values.province = values.province.toString();
    dispatch(createDonerAction(values));
  };

  return (
    <div style={{ padding: "20px 50px" }}>
      <Spinner spinning={resourceState.loading}>
        <Form
          onFinish={createDonerSubmit}
          form={createDonerForm}
          layout='vertical'
        >
          <Row gutter={[10, 10]}>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='First Name'
                name='firstName'
                rules={[
                  {
                    required: true,
                    message: "Please enter first name.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item label='Middle Name' name='middleName'>
                <Input />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='Last Name'
                name='lastName'
                rules={[
                  {
                    required: true,
                    message: "Please enter last name.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='Blood Group'
                name='bloodGroup'
                rules={[
                  {
                    required: true,
                    message: "Please enter blood group.",
                  },
                ]}
              >
                <Select>
                  <Select.Option value='A+'>A+</Select.Option>
                  <Select.Option value='A-'>A-</Select.Option>
                  <Select.Option value='B+'>B+</Select.Option>
                  <Select.Option value='B-'>B-</Select.Option>
                  <Select.Option value='AB+'>AB+</Select.Option>
                  <Select.Option value='AB-'>AB-</Select.Option>
                  <Select.Option value='O+'>O+</Select.Option>
                  <Select.Option value='O-'>O-</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='Mobile'
                name='mobile'
                rules={[
                  {
                    required: true,
                    message: "Please enter mobile number.",
                  },
                ]}
              >
                <Input maxLength={10} minLength={10} />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='Age'
                name='age'
                rules={[
                  {
                    required: true,
                    message: "Please enter age.",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item label='Email' name='email'>
                <Input />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='Province'
                name='province'
                rules={[
                  {
                    required: true,
                    message: "Please enter province.",
                  },
                ]}
              >
                <Select
                  showSearch
                  showArrow
                  allowClear
                  optionFilterProp='children'
                  placeholder='Select Province'
                  onChange={onChangeProvince}
                >
                  {resourceState.getProvince.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='District'
                name='district'
                rules={[
                  {
                    required: true,
                    message: "Please enter district.",
                  },
                ]}
              >
                <Select
                  showSearch
                  showArrow
                  allowClear
                  optionFilterProp='children'
                  placeholder='Select Province'
                  onChange={onChangeProvince}
                >
                  {resourceState.getDistrict.map((item) => (
                    <Select.Option key={item.district} value={item.district}>
                      {item.district}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='City'
                name='city'
                rules={[
                  {
                    required: true,
                    message: "Please enter city.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='Ward No'
                name='ward'
                rules={[
                  {
                    required: true,
                    message: "Please enter Ward No.",
                  },
                ]}
              >
                <Select
                  showSearch
                  showArrow
                  allowClear
                  optionFilterProp='children'
                  placeholder='Select Ward No'
                >
                  <Select.Option key='1' value='1'>
                    1
                  </Select.Option>
                  <Select.Option key='2' value='2'>
                    2
                  </Select.Option>
                  <Select.Option key='3' value='3'>
                    3
                  </Select.Option>
                  <Select.Option key='4' value='4'>
                    4
                  </Select.Option>
                  <Select.Option key='5' value='5'>
                    5
                  </Select.Option>
                  <Select.Option key='6' value='6'>
                    6
                  </Select.Option>
                  <Select.Option key='7' value='7'>
                    7
                  </Select.Option>
                  <Select.Option key='8' value='8'>
                    8
                  </Select.Option>
                  <Select.Option key='9' value='9'>
                    9
                  </Select.Option>
                  <Select.Option key='10' value='10'>
                    10
                  </Select.Option>
                  <Select.Option key='11' value='11'>
                    11
                  </Select.Option>
                  <Select.Option key='12' value='12'>
                    12
                  </Select.Option>
                  <Select.Option key='13' value='13'>
                    13
                  </Select.Option>
                  <Select.Option key='14' value='14'>
                    14
                  </Select.Option>
                  <Select.Option key='15' value='15'>
                    15
                  </Select.Option>
                  <Select.Option key='16' value='16'>
                    16
                  </Select.Option>
                  <Select.Option key='17' value='17'>
                    17
                  </Select.Option>
                  <Select.Option key='18' value='18'>
                    18
                  </Select.Option>
                  <Select.Option key='19' value='19'>
                    19
                  </Select.Option>
                  <Select.Option key='20' value='20'>
                    20
                  </Select.Option>
                  <Select.Option key='21' value='21'>
                    21
                  </Select.Option>
                  <Select.Option key='22' value='22'>
                    22
                  </Select.Option>
                  <Select.Option key='23' value='23'>
                    23
                  </Select.Option>
                  <Select.Option key='24' value='24'>
                    24
                  </Select.Option>
                  <Select.Option key='25' value='25'>
                    25
                  </Select.Option>
                  <Select.Option key='26' value='26'>
                    26
                  </Select.Option>
                  <Select.Option key='27' value='27'>
                    27
                  </Select.Option>
                  <Select.Option key='28' value='28'>
                    28
                  </Select.Option>
                  <Select.Option key='29' value='29'>
                    29
                  </Select.Option>
                  <Select.Option key='30' value='30'>
                    30
                  </Select.Option>
                  <Select.Option key='31' value='31'>
                    31
                  </Select.Option>
                  <Select.Option key='32' value='32'>
                    32
                  </Select.Option>
                  <Select.Option key='33' value='33'>
                    33
                  </Select.Option>
                  <Select.Option key='34' value='34'>
                    34
                  </Select.Option>
                  <Select.Option key='35' value='35'>
                    35
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item
                label='tole'
                name='tole'
                rules={[
                  {
                    required: true,
                    message: "Please enter tole.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  style={{ fontWeight: "bold" }}
                >
                  Save
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spinner>
    </div>
  );
};

export default AddBlood;
